import { formatLongDateLabel, toUiDate } from './localization';

export const MONDAY_FIRST_WEEKDAY_KEYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const;

export const MONTH_I18N_KEYS = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
] as const;

export type CalendarLabelTranslator = (key: string) => string;

export const getMondayWeekdayLabelsLocalized = (t: CalendarLabelTranslator): string[] => (
  MONDAY_FIRST_WEEKDAY_KEYS.map((key) => t(`weekdays.${key}`))
);

export const formatMonthYearLabel = (date: Date, t: CalendarLabelTranslator): string => {
  const monthKey = MONTH_I18N_KEYS[date.getMonth()];
  return `${t(`months.${monthKey}`)} ${date.getFullYear()}`;
};

export const getWeekdayIndexForUiCalendarDate = (value: string | number | Date): number | null => {
  const date = toUiDate(value);
  if (!date) {
    return null;
  }

  return (date.getDay() + 6) % 7;
};

export const formatAvailabilityDayHeadingLabel = (
  value: string | number | Date,
  t: CalendarLabelTranslator,
): string => {
  const weekdayIndex = getWeekdayIndexForUiCalendarDate(value);
  const dateLabel = formatLongDateLabel(value);

  if (weekdayIndex === null) {
    return dateLabel;
  }

  const weekdayKey = MONDAY_FIRST_WEEKDAY_KEYS[weekdayIndex];
  const weekday = t(`weekdaysLong.${weekdayKey}`);

  if (!dateLabel) {
    return weekday;
  }

  return `${weekday}, ${dateLabel}`;
};
